/* ============================================================
   pm-stockists-v2.js
   Extracted from Pestleandmortar_Stockists_v6Brand.html.
   Conditionally loaded by layout/theme.liquid on the
   page.stockists-v2 template only. Depends on Leaflet (loaded
   first in theme.liquid alongside this file).
   ============================================================ */
(function(){
  /* Each Stockists v2 section ships its own .stk-v2-root wrapper —
     so scope queries to document-wide .stk-v2-root descendants, not
     to the first wrapper only (which leaves later sections stuck at
     opacity:0 from the [data-reveal] start state). */

  /* Reveal on scroll */
  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.stk-v2-root [data-reveal]').forEach(function(el){ io.observe(el); });
  }

  /* ============================================================
     COUNTRY TAB CLICK — single delegated handler that ALWAYS fires
     (whether Leaflet loaded or not). Updates highlight, heading,
     scrolls to map. Calls window.__stkShowCountry (set later by
     the map init block) to actually filter the Leaflet pins.
     ============================================================ */
  function getAllTabs(){ return document.querySelectorAll('.stk-v2-root .country-tabs .tab'); }
  document.addEventListener('click', function(e){
    var tab = e.target.closest && e.target.closest('.stk-v2-root .country-tabs .tab');
    if (!tab) return;
    e.preventDefault();
    var country = tab.dataset.country;
    if (!country) return;

    getAllTabs().forEach(function(x){ x.classList.toggle('is-on', x === tab); });

    var heading = document.getElementById('map-heading');
    if (heading){
      var total;
      if (typeof window.__stkCounts === 'object' && window.__stkCounts){
        total = country === 'ALL' ? window.__stkCounts.__ALL : (window.__stkCounts[country] || 0);
      } else {
        total = tab.querySelector('.ct') ? parseInt(tab.querySelector('.ct').textContent, 10) : 0;
      }
      var label = country === 'ALL' ? 'View all' : (country === 'USA' ? 'United States' : country);
      heading.textContent = label;
    }

    if (typeof window.__stkShowCountry === 'function') window.__stkShowCountry(country);

    var section = document.querySelector('.stk-v2-root .map-list');
    if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ============================================================
     HERO FORM SCROLL — always-on listeners that scroll to the
     map regardless of whether Leaflet loaded. Filtering/flying
     is added later in the Leaflet block via window.__stkDoSearch
     and window.__stkNearMe (defined after the map is ready).
     ============================================================ */
  function scrollToMapList(){
    var section = document.querySelector('.stk-v2-root .map-list');
    if (!section) return;
    var top  = section.getBoundingClientRect().top + window.pageYOffset;
    var off  = (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--pnm-util-h-v2'), 10) || 36)
             + (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--pnm-header-h'), 10) || 76) + 20;
    window.scrollTo({ top: top - off, behavior: 'smooth' });
  }
  var heroFormEl = document.querySelector('.stk-v2-root .stk-hero .stk-search');
  if (heroFormEl){
    var heroInputEl = heroFormEl.querySelector('input[type="text"]');
    var heroGeoEl   = heroFormEl.querySelector('.geo');
    heroFormEl.addEventListener('submit', function(e){
      e.preventDefault();
      var q = heroInputEl ? heroInputEl.value : '';
      if (typeof window.__stkDoSearch === 'function') window.__stkDoSearch(q);
      else scrollToMapList();
    });
    if (heroGeoEl){
      heroGeoEl.addEventListener('click', function(e){
        e.preventDefault();
        if (typeof window.__stkNearMe === 'function') window.__stkNearMe(heroGeoEl);
        else scrollToMapList();
      });
    }
    if (heroInputEl){
      heroInputEl.addEventListener('keydown', function(e){
        if (e.key === 'Enter'){
          e.preventDefault();
          if (typeof window.__stkDoSearch === 'function') window.__stkDoSearch(heroInputEl.value);
          else scrollToMapList();
        }
      });
    }
  }

  /* FAQ accordion */
  var faqRows = document.querySelectorAll('.stk-v2-root .stk-faq .qrow');
  faqRows.forEach(function(r){
    r.addEventListener('click', function(){
      faqRows.forEach(function(x){ if (x !== r) x.classList.remove('is-open'); });
      r.classList.toggle('is-open');
    });
  });

  /* ============================================================
     LEAFLET MAP — CartoDB Positron tiles (monochrome, no key)
     ============================================================ */
  if (typeof L === 'undefined') return;
  var canvas = document.getElementById('bigmap-canvas');
  if (!canvas) return;

  var stockists = [];

  /* ============================================================
     STOCKIST DATA — sourced entirely from "stockist_v2" metaobjects
     (shop.metaobjects.stockist_v2.values). The maplist Liquid emits
     them as a JSON blob in <script id="stk-v2-extra-data">. Add/edit
     stockists from admin → Content → Metaobjects → Stockist (v2).
     Shopify caps paginate at 250 per render; if the metaobject has
     more than 250 entries we fan out extra Section Rendering API
     calls (?page=2..N&section_id=pm-stk-v2-maplist) to pull the rest
     before the map/tabs are built.
     ============================================================ */
  function ingestExtraJson(text){
    try {
      var arr = JSON.parse(text || '[]');
      if (!Array.isArray(arr)) return;
      arr.forEach(function(s){
        var lat = parseFloat(s.lat), lng = parseFloat(s.lng);
        if (!s || !s.name || isNaN(lat) || isNaN(lng) || !s.country) return;
        stockists.push({
          name:    s.name,
          type:    s.type    || '',
          addr:    s.addr    || '',
          city:    s.city    || '',
          country: s.country,
          lat:     lat,
          lng:     lng,
          flagship: false
        });
      });
    } catch(e){ console.error('[stk-v2] extra-data parse failed:', e); }
  }

  var extraEl = document.getElementById('stk-v2-extra-data');
  if (extraEl) ingestExtraJson(extraEl.textContent);

  /* No JS-side pagination fetch — Shopify's paginate on metaobject
     .values doesn't honour the ?page= URL param, so subsequent fetches
     just return page 1 again (which double-counted every country in
     testing). All stockists must come from the initial script tag. */
  var extraFetches = [];

  /* Defer the rest of init (tabs + map + markers) until every extra
     page has been ingested — otherwise Australia/Spain/etc. that live
     past page 1 would never appear in the tab strip. */
  Promise.all(extraFetches).then(function(){
  /* ============================================================
     COUNTRY TABS — auto-rendered from the parsed stockist data so
     they always reflect what's actually plotted on the map. The
     Liquid section (pm-stk-v2-tabs.liquid) only provides an empty
     [data-stk-tabs-host] container.
     ============================================================ */
  (function renderCountryTabs(){
    var host = document.querySelector('[data-stk-tabs-host]');
    if (!host) return;
    var allLabel = host.getAttribute('data-all-label') || 'View all';

    /* Map Shopify Markets ISO codes → the country strings used in metaobjects.
       Extend this when new stockist countries are added. */
    var ISO_TO_COUNTRY = {
      IE:'Ireland', GB:'United Kingdom', US:'USA', DK:'Denmark', DE:'Germany',
      NL:'Netherlands', ES:'Spain', IS:'Iceland', BM:'Bermuda', TH:'Thailand',
      AU:'Australia', SE:'Sweden', EE:'Estonia', CZ:'Czech Republic', SK:'Slovakia'
    };
    var userIso = (host.getAttribute('data-user-iso') || '').toUpperCase();
    var userCountryRaw = host.getAttribute('data-user-country') || '';
    var userCountry = ISO_TO_COUNTRY[userIso] || userCountryRaw || '';

    var counts = {};
    stockists.forEach(function(s){
      if (!s.country) return;
      counts[s.country] = (counts[s.country] || 0) + 1;
    });
    var countries = Object.keys(counts).sort();
    if (!countries.length) return;

    /* Hoist the visitor's country to the front if we plot stockists there. */
    if (userCountry && counts[userCountry]){
      countries = [userCountry].concat(countries.filter(function(c){ return c !== userCountry; }));
    }

    var html = countries.map(function(c, i){
      var slug = c.toLowerCase().replace(/\s+/g, '-');
      var on = i === 0 ? ' is-on' : '';
      return '<a class="tab' + on + '" data-country="' + c + '" href="#' + slug + '">'
        + c + ' <span class="ct">' + counts[c] + '</span></a>';
    }).join('');
    html += '<a class="tab" data-country="ALL" href="#all">' + allLabel
      + ' <span class="ct">' + stockists.length + '</span></a>';
    host.innerHTML = html;
  })();

  /* Init map — centred on Ireland */
  var map = L.map(canvas, {
    center: [53.5, -8.0],
    zoom: 7,
    zoomControl: false,
    scrollWheelZoom: false,
    attributionControl: true
  });

  /* OpenStreetMap standard tiles — no API key required. The CSS
     grayscale + contrast filter on .stk-v2-root .leaflet-tile-pane keeps
     the monochrome look that Carto Positron gave us. */
  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 19
  }).addTo(map);

  map.on('focus', function(){ map.scrollWheelZoom.enable(); });
  map.on('blur',  function(){ map.scrollWheelZoom.disable(); });

  /* Force Leaflet to recalc tile container after the [data-reveal]
     opacity/transform settles — without this the map often paints at
     0×0 and stays grey because the container had transform:translateY
     applied when L.map() was called. */
  function refreshMapSize(){ try { map.invalidateSize(); } catch(_){} }
  setTimeout(refreshMapSize, 120);
  setTimeout(refreshMapSize, 800);
  window.addEventListener('load',   refreshMapSize);
  window.addEventListener('resize', refreshMapSize);
  if ('IntersectionObserver' in window){
    var bigmap = canvas.closest('.bigmap');
    if (bigmap){
      var mio = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (e.isIntersecting){ refreshMapSize(); mio.unobserve(e.target); } });
      }, { threshold: 0.1 });
      mio.observe(bigmap);
    }
  }

  function makePin(){
    /* Single marker style — every stockist is treated equally
       (department stores like Brown Thomas / Liberty / Bloomingdale's
       are just stockists, not "ours"). */
    return L.divIcon({
      className: 'pm-pin',
      iconSize: [24, 24],
      iconAnchor: [12, 12],
      popupAnchor: [0, -10]
    });
  }

  var layer = L.layerGroup().addTo(map);
  var markersByCountry = {};

  stockists.forEach(function(s){
    var m = L.marker([s.lat, s.lng], { icon: makePin() });
    var dir = 'https://www.google.com/maps/dir/?api=1&destination=' + s.lat + ',' + s.lng;
    m.bindPopup(
      '<div class="pm-popup">' +
        '<p class="ty">' + (s.type || '') + '</p>' +
        '<h4>' + s.name + '</h4>' +
        '<p class="ad">' + s.addr + '</p>' +
        '<a class="lk" href="' + dir + '" target="_blank" rel="noopener">Directions</a>' +
      '</div>',
      { closeButton: true, autoClose: true }
    );
    m.addTo(layer);
    (markersByCountry[s.country] = markersByCountry[s.country] || []).push(m);
  });

  var allBounds = L.latLngBounds(stockists.map(function(s){ return [s.lat, s.lng]; }));

  function showCountry(country){
    layer.clearLayers();

    var targetBounds;
    if (country === 'ALL'){
      Object.keys(markersByCountry).forEach(function(k){ markersByCountry[k].forEach(function(m){ m.addTo(layer); }); });
      targetBounds = allBounds.pad(0.15);
    } else {
      var markers = markersByCountry[country] || [];
      markers.forEach(function(m){ m.addTo(layer); });
      if (!markers.length) return;
      targetBounds = L.latLngBounds(markers.map(function(m){ return m.getLatLng(); })).pad(0.20);
    }

    /* Deferred pan — invalidateSize first so bounds calc gets the real
       viewport, then fly. Wrapped in rAF + small timeout so it runs AFTER
       the click handler's scrollIntoView has settled (otherwise the
       concurrent layout shift can swallow the animation). Two-step:
       instant fitBounds first (guarantees the move even if the animation
       gets cancelled), then a brief flyTo for the smooth feel. */
    requestAnimationFrame(function(){
      try { map.invalidateSize(); } catch(_){}
      setTimeout(function(){
        try {
          map.fitBounds(targetBounds, { animate: false, maxZoom: country === 'ALL' ? 5 : 11 });
          /* short flyTo to soften the snap */
          var c = targetBounds.getCenter();
          var z = map.getZoom();
          map.flyTo(c, z, { duration: 0.6 });
        } catch(e){ console.error('[stk-v2] pan failed:', e); }
      }, 60);
    });
  }

  /* ============================================================
     DYNAMIC LIST RENDERER — generate the .region / .stk rows in
     the list column from the stockists[] array, grouped by city,
     filtered by selected country. Replaces the static block-driven
     regions on country click so the list always matches the map.
     ============================================================ */
  function escapeHtml(s){
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }
  function pinLabel(s){
    if (s.type && /pharmacy/i.test(s.type)) return 'RX';
    var word = (s.name || '').replace(/^the\s+/i, '').trim().split(/\s+/)[0] || '';
    return (word.charAt(0) || '?').toUpperCase();
  }
  /* Single neutral style for every stockist — no flagship distinction. */
  function pinClass(){ return ''; }
  function typeClass(){ return ''; }

  function renderCountryList(country){
    var listCol = document.querySelector('.stk-v2-root .map-list .list-col');
    if (!listCol) return;

    /* Wipe all previously-rendered content (regions, the dynamic show-more
       button, and the legacy static .btn.ghost load-more button from the
       Liquid template) so the list rebuilds cleanly on every country
       change. The filter-bar at the top stays. */
    listCol.querySelectorAll('.region, .stk-show-more, .btn.ghost').forEach(function(r){ r.remove(); });

    /* Gather stockists for this country (or all) */
    var source = country === 'ALL' ? stockists : stockists.filter(function(s){ return s.country === country; });
    if (!source.length){
      var empty = document.createElement('div');
      empty.className = 'region';
      empty.innerHTML = '<h3>No stockists <span class="ct">in this region yet</span></h3>';
      var firstAfterFilter = listCol.querySelector('.filter-bar').nextElementSibling;
      listCol.insertBefore(empty, firstAfterFilter);
      return;
    }

    /* Group by city (fallback to country if city blank) */
    var groups = {};
    var order = [];
    source.forEach(function(s){
      var key = (s.city && s.city.trim()) || s.country;
      if (!groups[key]){ groups[key] = []; order.push(key); }
      groups[key].push(s);
    });

    /* Sort: largest groups first (so London / Dublin lead) */
    order.sort(function(a, b){ return groups[b].length - groups[a].length; });

    var insertBeforeNode = listCol.querySelector('.filter-bar').nextElementSibling;

    var INITIAL_LIMIT = 6;
    var shownSoFar = 0;
    var totalRows = source.length;

    var frag = document.createDocumentFragment();
    order.forEach(function(key){
      var rows = groups[key];
      var region = document.createElement('div');
      region.className = 'region';
      var rowsHtml = rows.map(function(s){
        var dir = 'https://www.google.com/maps/dir/?api=1&destination=' + s.lat + ',' + s.lng;
        var hidden = shownSoFar >= INITIAL_LIMIT ? ' is-hidden' : '';
        shownSoFar++;
        return '<div class="stk' + hidden + '" data-lat="' + s.lat + '" data-lng="' + s.lng + '" role="button" tabindex="0">' +
          '<span class="pin ' + pinClass(s) + '">' + escapeHtml(pinLabel(s)) + '</span>' +
          '<div class="det">' +
            '<p class="nm">' + escapeHtml(s.name) + '</p>' +
            '<p class="ty">' + escapeHtml(s.type || '') + '</p>' +
            '<p class="addr">' + escapeHtml(s.addr || '') + '</p>' +
          '</div>' +
          '<a class="lk" href="' + dir + '" target="_blank" rel="noopener">Directions</a>' +
        '</div>';
      }).join('');
      region.innerHTML = '<h3>' + escapeHtml(key) + ' <span class="ct">' + rows.length + ' stockist' + (rows.length === 1 ? '' : 's') + '</span></h3>' + rowsHtml;

      /* If every row in this region is hidden, hide the region header too
         until "show more" is clicked. */
      var visibleInRegion = Array.prototype.filter.call(region.querySelectorAll('.stk'), function(r){ return !r.classList.contains('is-hidden'); }).length;
      if (visibleInRegion === 0) region.classList.add('is-collapsed');

      frag.appendChild(region);
    });

    /* Show-more button — appears below the list when there are more
       than 6 stockists. Clicking reveals all hidden rows + regions. */
    if (totalRows > INITIAL_LIMIT){
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'stk-show-more';
      btn.textContent = 'Show all ' + totalRows + ' locations';
      btn.addEventListener('click', function(){
        listCol.querySelectorAll('.stk.is-hidden').forEach(function(r){ r.classList.remove('is-hidden'); });
        listCol.querySelectorAll('.region.is-collapsed').forEach(function(r){ r.classList.remove('is-collapsed'); });
        btn.remove();
      });
      frag.appendChild(btn);
    }

    listCol.insertBefore(frag, insertBeforeNode);
  }

  /* Track user interaction so the deferred initial-fit doesn't
     clobber a country the user has already selected within 250ms
     of page load. */
  var userHasSelectedCountry = false;

  /* Expose for the delegated tab click handler above */
  window.__stkShowCountry = function(country){
    userHasSelectedCountry = true;
    try { showCountry(country); } catch(e){ console.error('[stk-v2] showCountry threw:', e); }
    try { renderCountryList(country); } catch(e){ console.error('[stk-v2] renderCountryList threw:', e); }
    console.log('[stk-v2] switched to country:', country);
  };
  window.__stkCounts = (function(){
    var out = { __ALL: stockists.length };
    Object.keys(markersByCountry).forEach(function(k){ out[k] = markersByCountry[k].length; });
    return out;
  })();

  /* Initial fit — defer until invalidateSize has run so the bounds
     calculation gets the real viewport size, not 0×0. Guarded by
     userHasSelectedCountry so it never overwrites a user click. */
  function initialFit(){
    try { map.invalidateSize(); } catch(_){}
    if (userHasSelectedCountry) return;
    showCountry('Ireland');
    renderCountryList('Ireland');
    var heading = document.getElementById('map-heading');
    if (heading){
      heading.textContent = 'Ireland';
    }
  }
  setTimeout(initialFit, 250);

  var zin = document.getElementById('map-zoom-in');
  var zout = document.getElementById('map-zoom-out');
  var zrst = document.getElementById('map-reset');
  if (zin)  zin.onclick  = function(){ map.zoomIn(); };
  if (zout) zout.onclick = function(){ map.zoomOut(); };
  if (zrst) zrst.onclick = function(){ showCountry('ALL'); };

  /* ============================================================
     ROW CLICK → MAP PAN — delegated handler on the list column.
     Clicking anywhere on a .stk row (except the Directions link)
     flies the map to that stockist's lat/lng and opens the popup.
     ============================================================ */
  var listColEl = document.querySelector('.stk-v2-root .map-list .list-col');
  if (listColEl){
    function panToRow(row){
      var lat = parseFloat(row.getAttribute('data-lat'));
      var lng = parseFloat(row.getAttribute('data-lng'));
      if (isNaN(lat) || isNaN(lng)) return;
      try {
        map.flyTo([lat, lng], 14, { duration: 0.8 });
        /* Open the matching marker's popup so the user sees confirmation */
        Object.keys(markersByCountry).some(function(country){
          var hit = (markersByCountry[country] || []).find(function(mm){
            var ll = mm.getLatLng();
            return Math.abs(ll.lat - lat) < 1e-6 && Math.abs(ll.lng - lng) < 1e-6;
          });
          if (hit){ setTimeout(function(){ hit.openPopup(); }, 850); return true; }
          return false;
        });
      } catch(_){}
    }
    listColEl.addEventListener('click', function(e){
      if (e.target.closest('.lk')) return;            /* preserve Directions link */
      var row = e.target.closest('.stk');
      if (!row) return;
      panToRow(row);
    });
    listColEl.addEventListener('keydown', function(e){
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var row = e.target.closest('.stk');
      if (!row) return;
      e.preventDefault();
      panToRow(row);
    });
  }

  /* ============================================================
     LIST-COL FILTER BAR — search input filters both the static
     .stk accordion rows (by text content) and the Leaflet pin set
     (by name / address / city) live as the user types.
     ============================================================ */
  var filterBar = document.querySelector('.stk-v2-root .map-list .list-col .filter-bar');
  if (filterBar){
    var filterInput  = filterBar.querySelector('input[type="text"]');
    var filterSelect = filterBar.querySelector('select');

    function applyListFilter(){
      var q = (filterInput && filterInput.value || '').trim().toLowerCase();
      var county = (filterSelect && filterSelect.value && filterSelect.value !== 'All counties') ? filterSelect.value.toLowerCase() : '';
      var hasFilter = !!(q || county);

      /* Filter the .stk accordion rows by text content. When a filter is
         active we also strip the initial-6-row .is-hidden state so all
         rows are candidates — otherwise rows past the 6th never become
         visible no matter what you type. */
      var regions = document.querySelectorAll('.stk-v2-root .list-col .region');
      regions.forEach(function(region){
        var rows = region.querySelectorAll('.stk');
        var anyVisible = 0;
        rows.forEach(function(row){
          if (hasFilter) row.classList.remove('is-hidden');
          var txt = (row.textContent || '').toLowerCase();
          var match = (!q || txt.indexOf(q) !== -1) && (!county || txt.indexOf(county) !== -1);
          row.style.display = match ? '' : 'none';
          if (match) anyVisible++;
        });
        /* reveal any collapsed regions whose rows may now match */
        if (hasFilter) region.classList.remove('is-collapsed');
        /* hide the region header when nothing matches inside it */
        region.style.display = anyVisible === 0 && hasFilter ? 'none' : '';
      });

      /* Hide the "Show all N locations" button while filtering — it's
         meaningless when the filter has already revealed everything. */
      var showMoreBtn = document.querySelector('.stk-v2-root .list-col .stk-show-more');
      if (showMoreBtn) showMoreBtn.style.display = hasFilter ? 'none' : '';

      /* Filter the map pins by name / city / address match */
      layer.clearLayers();
      var visiblePins = [];
      stockists.forEach(function(s, i){
        var hay = (s.name + ' ' + s.city + ' ' + s.addr + ' ' + s.country).toLowerCase();
        var match = (!q || hay.indexOf(q) !== -1) && (!county || hay.indexOf(county) !== -1);
        if (match){
          var m = markersByCountry[s.country] && markersByCountry[s.country].find(function(mm){
            return mm.getLatLng().lat === s.lat && mm.getLatLng().lng === s.lng;
          });
          if (m){ m.addTo(layer); visiblePins.push(m); }
        }
      });
      if (visiblePins.length){
        var b = L.latLngBounds(visiblePins.map(function(m){ return m.getLatLng(); }));
        map.fitBounds(b.pad(0.20), { animate: true, maxZoom: 12 });
      }
    }

    if (filterInput){
      var t;
      filterInput.addEventListener('input', function(){
        clearTimeout(t); t = setTimeout(applyListFilter, 180);
      });
    }
    if (filterSelect){
      filterSelect.addEventListener('change', applyListFilter);
    }
  }

  /* ============================================================
     HERO SEARCH + NEAR-ME — wire the hero form so submitting jumps
     to the map and filters by country (or city/store name match).
     "Near me" uses navigator.geolocation to find the user's lat/lng
     and pans the map to the nearest stockist.
     ============================================================ */
  /* ============================================================
     HERO SEARCH + NEAR-ME — Leaflet-dependent logic exposed on
     window. The top-of-file form listeners call these if defined,
     otherwise fall back to scrollToMapList(). Order matters: this
     block runs AFTER the form listeners are attached, so by the
     time the user clicks Search/Near me the window methods exist.
     ============================================================ */
  function highlightCountry(countryKey){
    document.querySelectorAll('.stk-v2-root .country-tabs .tab').forEach(function(t){
      t.classList.toggle('is-on', t.dataset.country === countryKey);
    });
    userHasSelectedCountry = true;
    showCountry(countryKey);
    renderCountryList(countryKey);
    var h = document.getElementById('map-heading');
    if (h){
      var label = countryKey === 'ALL' ? 'View all' : (countryKey === 'USA' ? 'United States' : countryKey);
      h.textContent = label;
    }
  }

  /* Render an arbitrary list of stockists (e.g. search results) into
     the list column. Groups by city, sorted by group size — same shape
     as renderCountryList. */
  function renderSearchList(matches){
    var listCol = document.querySelector('.stk-v2-root .map-list .list-col');
    if (!listCol) return;

    listCol.querySelectorAll('.region, .stk-show-more, .btn.ghost').forEach(function(r){ r.remove(); });
    var insertBeforeNode = listCol.querySelector('.filter-bar').nextElementSibling;

    if (!matches.length){
      var empty = document.createElement('div');
      empty.className = 'region';
      empty.innerHTML = '<h3>No results <span class="ct">try a different search</span></h3>';
      listCol.insertBefore(empty, insertBeforeNode);
      return;
    }

    var groups = {};
    var order = [];
    matches.forEach(function(s){
      var key = (s.city && s.city.trim()) || s.country;
      if (!groups[key]){ groups[key] = []; order.push(key); }
      groups[key].push(s);
    });
    order.sort(function(a, b){ return groups[b].length - groups[a].length; });

    var frag = document.createDocumentFragment();
    order.forEach(function(key){
      var rows = groups[key];
      var region = document.createElement('div');
      region.className = 'region';
      var rowsHtml = rows.map(function(s){
        var dir = 'https://www.google.com/maps/dir/?api=1&destination=' + s.lat + ',' + s.lng;
        return '<div class="stk" data-lat="' + s.lat + '" data-lng="' + s.lng + '" role="button" tabindex="0">' +
          '<span class="pin ' + pinClass(s) + '">' + escapeHtml(pinLabel(s)) + '</span>' +
          '<div class="det">' +
            '<p class="nm">' + escapeHtml(s.name) + '</p>' +
            '<p class="ty">' + escapeHtml(s.type || '') + '</p>' +
            '<p class="addr">' + escapeHtml(s.addr || '') + '</p>' +
          '</div>' +
          '<a class="lk" href="' + dir + '" target="_blank" rel="noopener">Directions</a>' +
        '</div>';
      }).join('');
      region.innerHTML = '<h3>' + escapeHtml(key) + ' <span class="ct">' + rows.length + ' stockist' + (rows.length === 1 ? '' : 's') + '</span></h3>' + rowsHtml;
      frag.appendChild(region);
    });

    listCol.insertBefore(frag, insertBeforeNode);
  }

  window.__stkDoSearch = function(q){
    q = (q || '').trim().toLowerCase();
    scrollToMapList();
    if (!q) return;
    userHasSelectedCountry = true;

    /* 1) Exact-ish country match — pan to whole country */
    var countries = Object.keys(markersByCountry);
    var hitCountry = countries.find(function(c){ return c.toLowerCase().indexOf(q) !== -1; });
    if (hitCountry){ highlightCountry(hitCountry); return; }

    /* 2) Find ALL matching stockists across every country */
    var matches = stockists.filter(function(s){
      return ((s.name || '') + ' ' + (s.city || '') + ' ' + (s.addr || '') + ' ' + (s.country || '')).toLowerCase().indexOf(q) !== -1;
    });

    if (!matches.length){
      /* No match — fall back to view-all */
      highlightCountry('ALL');
      return;
    }

    /* Clear all country-tab highlights (results may span multiple countries) */
    document.querySelectorAll('.stk-v2-root .country-tabs .tab').forEach(function(t){ t.classList.remove('is-on'); });

    /* Update heading to show the search context */
    var h = document.getElementById('map-heading');
    if (h){
      var safe = q.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      h.innerHTML = '"' + safe + '" · <em>' + matches.length + ' result' + (matches.length === 1 ? '' : 's') + '.</em>';
    }

    /* Show ONLY the matching pins on the map */
    layer.clearLayers();
    matches.forEach(function(s){
      var bucket = markersByCountry[s.country] || [];
      var m = bucket.find(function(mm){
        var ll = mm.getLatLng();
        return ll.lat === s.lat && ll.lng === s.lng;
      });
      if (m) m.addTo(layer);
    });

    /* Fly the map to fit the matches */
    setTimeout(function(){
      try {
        if (matches.length === 1){
          map.flyTo([matches[0].lat, matches[0].lng], 13, { duration: 1.0 });
        } else {
          var b = L.latLngBounds(matches.map(function(m){ return [m.lat, m.lng]; }));
          map.flyToBounds(b.pad(0.30), { duration: 1.0, maxZoom: 13 });
        }
      } catch(_){}
    }, 350);

    /* Render the list with all matches grouped by city */
    renderSearchList(matches);
  };

  window.__stkNearMe = function(btn){
    scrollToMapList();
    if (!navigator.geolocation) return;
    if (btn){ btn.disabled = true; var orig = btn.innerText; btn.innerText = 'Locating…'; }
    navigator.geolocation.getCurrentPosition(function(pos){
      var lat = pos.coords.latitude, lng = pos.coords.longitude;
      var best = null, bestD = Infinity;
      stockists.forEach(function(s){
        var dx = s.lat - lat, dy = s.lng - lng, d = dx*dx + dy*dy;
        if (d < bestD){ bestD = d; best = s; }
      });
      if (best){
        highlightCountry(best.country);
        setTimeout(function(){
          try { map.flyTo([best.lat, best.lng], 12, { duration: 1.0 }); } catch(_){}
        }, 350);
      }
      if (btn){ btn.disabled = false; btn.innerText = orig; }
    }, function(){
      if (btn){ btn.disabled = false; btn.innerText = orig; }
    }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 });
  };
  }); /* end Promise.all(extraFetches).then */
})();
